//Global variable
var isLogin = false
const $ = window.$

$(function() {
  const $container = $('#overlay-partner-detail-tryout')

  function checkLogin() {
    var codeUrl = '/checkLogin.s?s=' + Math.random()
    $.ajax({
      url: codeUrl,
      type: 'GET',
      async: false,
      cache: false,
      success: function(res) {
        let result = eval('(' + res + ')')
        if (result.code === 1) {
          isLogin = true
        } else {
          isLogin = false
        }
      },
      error: function() {
        console.error('####当前登录状态获取失败')
      },
    })
  }

  function refreshZeroTryoutForm() {
    // console.log('refreshed Zero Tryout Page!!!!!!!')
    // 清空所有选项 清空了10个
    $('#overlay-partner-detail-tryout #zero-tryout-company-name').val('')
    $('#overlay-partner-detail-tryout #zero-tryout-license-img').val('')
    $('#zero-tryout-license-name').text('')
    $('#overlay-partner-detail-tryout #zero-tryout-company-code').val('')
    $('#overlay-partner-detail-tryout #zero-tryout-company-intro').val('')
    $('#overlay-partner-detail-tryout #zero-tryout-company-scenario').val('')
    $('#overlay-partner-detail-tryout #zero-tryout-mag').val('')
    $('#overlay-partner-detail-tryout #zero-tryout-name').val('')
    $('#overlay-partner-detail-tryout #zero-tryout-cell').val('')
    $('#overlay-partner-detail-tryout #zero-tryout-email').val('')
    $('#overlay-partner-detail-tryout #zero-tryout-verification').val('')
    //由于应用了bootstrap-select, 清空select box 也需要调用它自己的方法 清空了3个
    $('#overlay-partner-detail-tryout .selectpicker').selectpicker('val', '')
    // 重新请求一张验证码
    getVerificationCodePic()
  }

  function getVerificationCodePic() {
    var codeUrl = '/vertifyCode.s?s=' + Math.random()
    $.ajax({
      url: codeUrl,
      type: 'GET',
      async: false,
      cache: false,
      success: function(/*res*/) {
        $('#zero-tryout-code').attr('src', codeUrl)
      },
      error: function() {
        console.error('验证码获取失败')
      },
    })
  }

  function getTypeRegionIndustryForZeroTryout() {
    // 服务类型列表
    var typeUrl = '/consoleApi/queryCustomerServiceList.s'
    $.ajax({
      url: typeUrl,
      type: 'GET',
      async: false,
      cache: false,
      success: function(result) {
        // var result = eval('(' + res + ')')
        if (result.code === 200) {
          var type = result.datas
          $.each(type, function(index, item) {
            // console.log('Customer Service List item', item)
            // 仅仅显示文本翻译和OCR
            // if (item.id === 1 || item.id === 6) {
            //   $('#overlay-partner-detail-tryout #zeroTryoutTypeOption').append(
            //     '<option  value="' + item.name + '">' + item.name + '</option>',
            //   )
            // }
          })
        } else {
          console.error('行业列表获取失败')
        }
      },
      error: function() {
        console.error('行业列表获取失败')
      },
    })

    // 所属地区列表
    var regionUrl = '/consoleApi/queryAreaList.s'
    $.ajax({
      url: regionUrl,
      type: 'GET',
      async: false,
      cache: false,
      success: function(result) {
        // var result = eval('(' + res + ')')
        if (result.code === 200) {
          var region = result.datas
          $.each(region, function(index, item) {
            $('#zeroTryoutRegionOption').append(
              '<option  value="' + item.id + '">' + item.name + '</option>',
            )
          })
        } else {
          console.error('地区列表获取失败')
        }
      },
      error: function() {
        console.error('地区列表获取失败')
      },
    })

    // 所属行业列表
    var industryUrl = '/consoleApi/queryCustomerIndustryList.s'
    $.ajax({
      url: industryUrl,
      type: 'GET',
      async: false,
      cache: false,
      success: function(result) {
        // var result = eval('(' + res + ')')
        if (result.code === 200) {
          var industry = result.datas
          $.each(industry, function(index, item) {
            $('#zeroTryoutIndustryOption').append(
              '<option  value="' + item.id + '">' + item.name + '</option>',
            )
          })
        } else {
          console.error('行业列表获取失败')
        }
      },
      error: function() {
        console.error('行业列表获取失败')
      },
    })
  }

  function submitZeroTryoutInfoForm() {
    let submitZeroTryoutInfoUrl = '/insertZeroTryout.s'
    let serviceRes = ''
    $.each(
      $('#overlay-partner-detail-tryout #zeroTryoutTypeOption').children(
        'option:selected',
      ),
      function(index, option) {
        if (index === 0) {
          serviceRes += option.value
        } else {
          serviceRes += ','
          serviceRes += option.value
        }
      },
    )
    // 包括验证码，一共14项，对于非必填项，留为空即可
    // 只有formData() 才能上传附件（图片，音频，视频，文件）
    let fd = new FormData()
    fd.append(
      'company',
      $.trim(
        $('#overlay-partner-detail-tryout #zero-tryout-company-name').val(),
      ),
    )
    fd.append('service', serviceRes)
    fd.append('licenseImgPath', $('#zero-tryout-license-img')[0].files[0])
    fd.append(
      'companyCode',
      $.trim(
        $('#overlay-partner-detail-tryout #zero-tryout-company-code').val(),
      ),
    )
    fd.append(
      'area',
      $('#overlay-partner-detail-tryout #zeroTryoutRegionOption')
        .children('option:selected')
        .val(),
    )
    fd.append(
      'industry',
      $('#overlay-partner-detail-tryout #zeroTryoutIndustryOption')
        .children('option:selected')
        .val(),
    )
    fd.append(
      'bizIntro',
      $.trim(
        $('#overlay-partner-detail-tryout #zero-tryout-company-intro').val(),
      ),
    )
    fd.append(
      'scenario',
      $.trim(
        $('#overlay-partner-detail-tryout #zero-tryout-company-scenario').val(),
      ),
    )
    fd.append(
      'magnitude',
      $.trim($('#overlay-partner-detail-tryout #zero-tryout-mag').val()),
    )
    fd.append(
      'contact',
      $.trim($('#overlay-partner-detail-tryout #zero-tryout-name').val()),
    )
    fd.append(
      'mobile',
      $('#overlay-partner-detail-tryout #zero-tryout-cell').val(),
    )
    fd.append(
      'email',
      $('#overlay-partner-detail-tryout #zero-tryout-email').val(),
    )
    fd.append(
      'position',
      $('#overlay-partner-detail-tryout #zeroTryoutJobOption')
        .children('option:selected')
        .val(),
    )
    fd.append(
      'vertifyCode',
      $('#overlay-partner-detail-tryout  #zero-tryout-verification').val(),
    )

    if (checkingZeroTryoutField()) {
      $.ajax({
        type: 'POST',
        url: submitZeroTryoutInfoUrl,
        crossDomain: true,
        data: fd,
        cache: false,
        contentType: false,
        processData: false,
        success: function(res) {
          let result = eval('(' + res + ')')
          if (result.code === '200') {
            window.alert('表单提交成功')
            $('#overlay-partner-detail-tryout').css('display', 'none')
            refreshZeroTryoutForm()
          } else if (result.code === '401') {
            window.alert('验证码错误')
            // 重新请求一张验证码
            getVerificationCodePic()
          } else if (result.code === '402') {
            window.alert('参数缺失')
            // 重新请求一张验证码
            getVerificationCodePic()
          } else if (result.code === '403') {
            window.alert('添加失败')
            // 重新请求一张验证码
            getVerificationCodePic()
          } else if (result.code === '405') {
            window.alert('验证码过期，请刷新')
            // 重新请求一张验证码
            getVerificationCodePic()
          } else {
            window.alert('其他错误')
          }
        },
        error: function() {
          window.alert('服务端错误，请稍后再试')
          // 重新请求一张验证码
          getVerificationCodePic()
        },
      })
    }
  }

  /**
   * 检查全部12个必填项
   */
  function checkingZeroTryoutField() {
    // 公司名字
    let companyString = $.trim(
      $('#overlay-partner-detail-tryout #zero-tryout-company-name').val(),
    )
    if (
      companyString === '' &&
      $('#overlay-partner-detail-tryout #zero-tryout-company-name').length > 0
    ) {
      window.alert('公司名称未填写，请填写')
      $('#zero-tryout-company-name').focus()
      return false
    }

    // 服务类型
    let serString = $.trim(
      $('#overlay-partner-detail-tryout #zeroTryoutTypeOption')
        .children('option:selected')
        .val(),
    )
    if (
      serString === '' &&
      $('#overlay-partner-detail-tryout #zeroTryoutTypeOption').length > 0
    ) {
      window.alert('服务类型未选择，请重新选择')
      $('#zeroTryoutTypeOption').focus()
      return false
    }
    // 公司营业执照照片
    let licenseImgString = $.trim(
      $('#overlay-partner-detail-tryout #zero-tryout-license-img').val(),
    )
    if (
      licenseImgString === '' &&
      $('#overlay-partner-detail-tryout #zero-tryout-license-img').length > 0
    ) {
      window.alert('公司营业执照未上传，请上传')
      $('#zero-tryout-license-img').focus()
      return false
    }

    // 组织机构代码号
    let companyCodeString = $.trim(
      $('#overlay-partner-detail-tryout #zero-tryout-company-code').val(),
    )
    if (
      companyCodeString === '' &&
      $('#overlay-partner-detail-tryout #zero-tryout-company-code').length > 0
    ) {
      window.alert('组织机构代码号，请填写')
      $('#zero-tryout-company-code').focus()
      return false
    }

    // 所属地区
    let areaString = $.trim(
      $('#overlay-partner-detail-tryout #zeroTryoutRegionOption')
        .children('option:selected')
        .val(),
    )
    if (
      areaString === '' &&
      $('#overlay-partner-detail-tryout #zeroTryoutRegionOption').length > 0
    ) {
      window.alert('所属地区未选择，请重新选择')
      $('#zeroTryoutRegionOption').focus()
      return false
    }
    // 所属行业
    let hyString = $.trim(
      $('#overlay-partner-detail-tryout #zeroTryoutIndustryOption')
        .children('option:selected')
        .val(),
    )
    if (
      hyString === '' &&
      $('#overlay-partner-detail-tryout #zeroTryoutIndustryOption').length > 0
    ) {
      window.alert('所属行业未选择，请重新选择')
      $('#zeroTryoutIndustryOption').focus()
      return false
    }

    // 使用场景
    let scenarioString = $.trim(
      $('#overlay-partner-detail-tryout #zero-tryout-company-scenario').val(),
    )
    if (
      scenarioString === '' &&
      $('#overlay-partner-detail-tryout #zero-tryout-company-scenario').length >
        0
    ) {
      window.alert('使用场景未填写，请填写')
      $('#zero-tryout-company-scenario').focus()
      return false
    }

    // 姓名
    let nameString = $.trim(
      $('#overlay-partner-detail-tryout #zero-tryout-name').val(),
    )
    if (
      nameString === '' &&
      $('#overlay-partner-detail-tryout #zero-tryout-name').length > 0
    ) {
      window.alert('联系人姓名未填写，请填写')
      $('#zero-tryout-name').focus()
      return false
    }
    // 电话
    let cellString = $.trim(
      $('#overlay-partner-detail-tryout #zero-tryout-cell').val(),
    )
    if (
      cellString === '' &&
      $('#overlay-partner-detail-tryout #zero-tryout-cell').length > 0
    ) {
      window.alert('联系人电话未填写，请填写')
      $('#zero-tryout-cell').focus()
      return false
    }
    // 邮箱
    let eString = $.trim(
      $('#overlay-partner-detail-tryout #zero-tryout-email').val(),
    )
    if (
      eString === '' &&
      $('#overlay-partner-detail-tryout #zero-tryout-email').length > 0
    ) {
      window.alert('联系人邮箱未填写，请填写')
      $('#zero-tryout-email').focus()
      return false
    }
    // 联系人职务
    let positionString = $.trim(
      $('#overlay-partner-detail-tryout #zeroTryoutJobOption')
        .children('option:selected')
        .val(),
    )
    if (
      positionString === '' &&
      $('#overlay-partner-detail-tryout #zeroTryoutJobOption').length > 0
    ) {
      window.alert('联系人职务未选择，请选择')
      $('#overlay-partner-detail-tryout #zeroTryoutJobOption').focus()
      return false
    }

    // 验证码
    let verString = $.trim(
      $('#overlay-partner-detail-tryout #zero-tryout-verification').val(),
    )
    if (
      verString === '' &&
      $('#overlay-partner-detail-tryout #zero-tryout-verification').length > 0
    ) {
      window.alert('验证码未填写，请填写')
      $('#overlay-partner-detail-tryout #zero-tryout-verification').focus()
      return false
    }

    return true
  }

  function setZeroTryoutName(/*event*/) {
    const file = $('#zero-tryout-license-img')[0].files[0]
    if (file.size > 5000000) {
      window.alert('文件过大，请上传一个小一些的文件')
      return
    }
    let fileName = $('#zero-tryout-license-img')[0].files[0]
      ? $('#zero-tryout-license-img')[0].files[0].name
      : ''
    $('#zero-tryout-license-name').text(fileName)
  }

  $container.find('.upload-input-btn').on('change', setZeroTryoutName)

  // 提交表单 发出POST call
  $('#zero-tryout-form-id').submit(function($event) {
    submitZeroTryoutInfoForm()
    $event.preventDefault()
    return false
  })

  //   $("#zero-tryout-submit").click(function(){
  //     submitZeroTryoutInfoForm();
  //   })

  // 关闭表单(右上角的X)
  $('#partner-info-close-btn-tryout').click(function() {
    $('#overlay-partner-detail-tryout').hide()
    //初始化清空所有选项
    refreshZeroTryoutForm()
  })
  // 关闭表单(下方的取消键)
  $('#zero-tryout-cancel').click(function() {
    $('#overlay-partner-detail-tryout').hide()
    //初始化清空所有选项
    refreshZeroTryoutForm()
  })

  //电话号码栏仅仅接受数字
  // Restrict input to digits by using a regular expression filter.
  $('#zero-tryout-cell').inputFilter(function(value) {
    return /^\d*$/.test(value)
  })

  // 点击立即试用键
  $(document).on('apply-for-trial', function() {
    if (isLogin) {
      $('#overlay-partner-detail-tryout').css('display', 'flex')
    } else {
      const origin_url = window.location.href
      window.location.href = '/redirect.s?redirectUrl=' + origin_url
    }
  })

  $container.find('#verification-refresh').click(function() {
    getVerificationCodePic()
  })

  // 加载当前页面需要做的事儿
  //初始化清空所有选项
  refreshZeroTryoutForm()
  // 获取各种列表
  getTypeRegionIndustryForZeroTryout()
  getVerificationCodePic()
  //检查当前登录的状态
  checkLogin()
})
